export const Field = ({ label, hint, count, max, children }) => (
  <label className="block">
    <span className="flex items-baseline justify-between gap-3">
      <span className="text-sm font-semibold text-[#0B192C]">{label}</span>
      {max ? <span className={`text-xs ${count > max ? "text-red-600" : "text-slate-500"}`}>{count}/{max}</span> : null}
    </span>
    <span className="mt-2 block">{children}</span>
    {hint ? <span className="mt-1.5 block text-xs text-slate-600">{hint}</span> : null}
  </label>
);

export const inputCls =
  "w-full rounded-xl border border-slate-300 bg-white px-4 py-3 text-base text-[#0B192C] outline-none transition-colors duration-200 placeholder:text-slate-400 focus:border-[#C87D55] focus:ring-2 focus:ring-[#C87D55]/20";

export const Card = ({ title, children }) => (
  <section className="rounded-3xl border border-slate-200 bg-white p-5 md:p-8">
    <h2 className="font-display text-2xl">{title}</h2>
    <div className="mt-6 space-y-5">{children}</div>
  </section>
);
